import Vue from 'vue';

Vue.filter('moment-date-compact', date => {
    if (!date) {
        return 'N/A'
    }

    return moment(date).format('L')
})

Vue.filter('moment-date', date => {
    if (!date) {
        return 'N/A'
    }

    return moment(date).format('LL')
})
  
Vue.filter('moment-date-time', date => {
    if (!date) {
        return 'N/A'
    }

    return moment(date).format('LLL')
})

Vue.filter('moment-french-datetime', date => {
    if (!date) {
        return 'N/A'
    }

    return moment(date).format('DD/MM/YYYY HH:mm:ss')
})
  
Vue.filter('moment-fulldatetime', date => {
    if (!date) {
        return 'N/A'
    }

    return moment(date).format('dddd LLL')
})
  
Vue.filter('moment-booking-date', date => {
    if (!date) {
        return 'N/A'
    }

    return moment(date).format('L LT')
})
  
Vue.filter('moment-booking-hour', date => {
    if (!date) {
        return 'N/A'
    }

    return moment(date).format('LT')
})
  
Vue.filter('bool-icon', value => {
    return value ? '<i class="fa fa-check text-green"></i>' : '<i class="fa fa-times text-red"></i>'
})


// WEBPACK FOOTER //
// ./client/filters.js